<div class="header">
  <div class="nav-list">
    <span>{{userdetails?.name}} ({{userdetails?.email}})</span>
    <i class="material-icons">notifications</i>
    <i class="material-icons" (click)="navigateprofile()">account_circle</i>
    <i class="material-icons" (click)="logout()">logout</i>
    <a class="nav-item" *ngIf="userdetails?.id == 1" (click)="dashboard()">
      <i class="material-icons">dashboard</i>
      Go to Dashboard
    </a>

  </div>
</div>
<div class="container">
   
    <div class="list-container">
      <div class="list-container row">
      <h3>Entities</h3>
    </div>
      <ul>
        <li *ngFor="let company of companies" (click)="selectCompany(company)">
          <span class="company-name">{{ company.name }}</span>
          <a (click)="redirectToComapany(company.domain_name,company.id,company.name)"><i class="material-icons">launch</i></a>
        </li>
      </ul>
    </div>
  </div>
